<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.66649 10.1143L12.7945 3.9856L13.7378 4.92826L6.66649 11.9996L2.42383 7.75693L3.36649 6.81426L6.66649 10.1143Z"
      fill="currentColor"
    />
  </svg>
</template>
